export const stylesRefs = {
  header: 'CoverageSection_header',
  gridHeader: 'CoverageSection_gridHeader',
  highlighted: 'CoverageSection_highlighted',
  sticky: 'CoverageSection_sticky',
  scrollable: 'CoverageSection_scrollable',
} as const
